import { useCallback } from 'react';

import { useChatStore } from '@stores/chat.store';
import { useChatConversations } from '@hooks/api/chat-websocket';

export const useBackButtonLogic = () => {
	const chatId = useChatStore((s) => s.conversation.active?.chatId);
	const { setConversationActive } = useChatConversations();

	const handleClick = useCallback(
		() => setConversationActive(null, chatId ?? ''),
		[chatId, setConversationActive],
	);

	return { handleClick };
};
